<template>
  <div
    v-if="listPictures.length > 0"
    class="list-container"
  >
    <waterfall
      :line-gap="200"
      :watch="listPictures"
      align="center"
      line="v"
      auto-resize="true"
    >
      <waterfall-slot
        v-for="(picture, index) in listPictures"
        :width="picture.width"
        :height="picture.height"
        :key="index"
        :order="index"
        class="item-container"
        move-class="item-move"
      >
        <div
          class="adminCaption"
          v-if="getPermission"
        >
          <v-checkbox
            dense
            :label="fileSize(picture.file_size)"
            color="red"
            background-color="white"
            v-model="picture.checked"
            class="radius"
          ></v-checkbox>
        </div>

        <v-icon
          class="details-img"
          color="blue"
          @click="showDetails(picture)"
          >mdi-alert-circle-outline</v-icon
        >

        <img
          v-if="!isVideo(picture)"
          class="item-img"
          :src="picture.sample"
          :alt="picture.tags"
          @click="open(picture)"
          @click.middle="openMiddle(picture)"
        />

        <video
          v-if="isVideo(picture)"
          controls
          class="item-img"
          type="video/mp4"
          :src="picture.sample"
          @click="open(picture)"
        />
      </waterfall-slot>
    </waterfall>
  </div>
</template>

<script>
import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'PicsResult',

  components: {
    Waterfall,
    WaterfallSlot
  },

  data: () => {
    return {
      isIntersecting: false,
      dialog: false,
      pictureDetails: {
        artist: null,
        character: null,
        id: null,
        pixiv_id: null,
        source: {
          category: null,
          resolution: null,
          purity: null,
          url: null
        },
        tags: null
      }
    }
  },

  computed: {
    ...mapState('listPictures', ['listPictures']),
    ...mapState('options', ['options']),

    ...mapGetters('admin', ['getPermission'])
  },

  methods: {
    ...mapActions('listPictures', ['setPictureDetails']),

    open(picture) {
      window.open(picture.file_url)
    },

    openMiddle(picture) {
      const newWindow = window.open(picture.source.url)
      newWindow.blur()
      window.focus()
    },

    fileSize(size) {
      return `${(size / 1000000).toFixed(2)} Mb` || 'noSize'
    },

    isVideo(picture) {
      return picture.mimetype === 'mp4'
    },

    showDetails(picture) {
      this.pictureDetails = picture

      if (this.pictureDetails.pixiv_id)
        this.pictureDetails.pixiv_id_url = `https://www.pixiv.net/en/artworks/${this.pictureDetails.pixiv_id}`

      if (this.options.target === 'wallheaven') {
        this.pictureDetails.source_url = this.pictureDetails.source.url
      }

      if (this.options.target === 'safebooru') {
        this.pictureDetails.source_url = this.pictureDetails.source
      }

      this.setPictureDetails(this.pictureDetails)

      this.$emit('openDetails')
    }
  }
}
</script>

<style
  scoped
  lang="scss"
>
ul {
  list-style-type: none;
}

.list-container {
  padding-top: 10px;
}

.item-container {
  padding: 5px;
}

.item-img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0.5px 0.5px 4px rgb(20, 20, 20);
  cursor: pointer;
  backface-visibility: hidden;
}

.item-move {
  transition: transform 0.1s cubic-bezier(0.55, 0, 0.1, 1);
}

.adminCaption {
  padding: 0;
  margin: 0;
  top: 0;
  position: absolute;
  opacity: 0.5;
  width: 95%;
}
.details-img {
  position: absolute;
  z-index: 1;
  bottom: 10px;
  left: 10px;
}

.tagsItems {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-height: 100vh;
}
</style>
